export class GridConstants {
}
GridConstants.lowerIndexBound = 1;
GridConstants.maxNumberOfRows = 1048576;
GridConstants.maxNumberOfColumns = 16384;
GridConstants.firstColumnName = 'A';
GridConstants.lastColumnName = 'XFD';
//# sourceMappingURL=tiles.js.map